var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "this noselect" },
    [
      _c(
        "h2",
        {
          staticClass: "text-center pointer",
          on: {
            "&click": function ($event) {
              return _vm.gotoCart.apply(null, arguments)
            },
          },
        },
        [_vm._v("Warenkorb")]
      ),
      _vm.cartItems.length === 0
        ? _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "spacer-40" }),
            _c("div", {}, [_vm._v("Der Korb ist leer")]),
          ])
        : _vm._e(),
      _vm.cartItems.length > 0
        ? _c("div", { staticClass: "pmRow" }, [_vm._m(0)])
        : _vm._e(),
      _vm._l(_vm.cartItems, function (item) {
        return _c("div", { staticClass: "itemRow pmRow" }, [
          item.isCoupon
            ? _c(
                "table",
                {
                  staticClass: "maxw items",
                  on: {
                    "&click": function ($event) {
                      return _vm.showCouponInfo(item)
                    },
                  },
                },
                [
                  _c("tr", [
                    _c("td", { staticClass: "b text-left" }, [
                      _c(
                        "div",
                        {
                          staticStyle: {
                            "overflow-x": "hidden",
                            "overflow-y": "clip",
                          },
                        },
                        [
                          _c("div", [
                            _vm._v(" " + _vm._s(item.nameToDisplay) + " "),
                          ]),
                          item.text
                            ? _c("div", { staticClass: "displayExtras" }, [
                                _vm._v(" " + _vm._s(item.text) + " "),
                              ])
                            : _vm._e(),
                        ]
                      ),
                    ]),
                    _c(
                      "td",
                      { staticClass: "c counterStuff" },
                      [
                        _c(
                          "v-row",
                          [
                            _c("v-col", [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "d-flex justify-end align-center maxh",
                                  staticStyle: { opacity: "0" },
                                },
                                [
                                  _c("img", {
                                    staticClass: "minusImg pointer invertImg",
                                    attrs: {
                                      src: require("../assets/icons/item-minus.png"),
                                    },
                                  }),
                                  _c("div", [_vm._v("0")]),
                                  _c("img", {
                                    staticClass: "plusImg pointer invertImg",
                                    attrs: {
                                      src: require("../assets/icons/item-plus.png"),
                                    },
                                  }),
                                ]
                              ),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              )
            : _c("table", { staticClass: "maxw items" }, [
                _c("tr", [
                  _c("td", { staticClass: "b text-left" }, [
                    _c(
                      "div",
                      {
                        staticStyle: {
                          "overflow-x": "hidden",
                          "overflow-y": "clip",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.gotoItem(item)
                          },
                        },
                      },
                      [
                        _c("div", [
                          item.isOffer
                            ? _c("span", [
                                item.usecase === "takeAway"
                                  ? _c("span", [_vm._v("Abholer-Angebot")])
                                  : _c("span", [_vm._v("Angebot")]),
                                _vm._v(": "),
                              ])
                            : _vm._e(),
                          _vm._v(
                            " " +
                              _vm._s(item.nameToDisplay) +
                              " " +
                              _vm._s(_vm.displayItemVol(item)) +
                              " "
                          ),
                        ]),
                        item.extras.length > 0
                          ? _c("div", { staticClass: "displayExtras" }, [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("extrasList")(item.extras, true)
                                  ) +
                                  " "
                              ),
                            ])
                          : _vm._e(),
                        item.notes
                          ? _c("div", { staticClass: "font-italic" }, [
                              _vm._v(_vm._s(item.notes)),
                            ])
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  _c(
                    "td",
                    { staticClass: "c counterStuff" },
                    [
                      _c(
                        "v-row",
                        [
                          _c("v-col", [
                            _c(
                              "div",
                              {
                                staticClass: "d-flex align-center maxh",
                                class: { "justify-end": !item.unikat },
                              },
                              [
                                !item.unikat
                                  ? _c("img", {
                                      staticClass: "minusImg pointer invertImg",
                                      attrs: {
                                        src: require("../assets/icons/item-minus.png"),
                                      },
                                      on: {
                                        "&click": function ($event) {
                                          return _vm.decrementCartItem(item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                                _c("div", [_vm._v(_vm._s(item.count))]),
                                !item.unikat
                                  ? _c("img", {
                                      staticClass: "plusImg pointer invertImg",
                                      attrs: {
                                        src: require("../assets/icons/item-plus.png"),
                                      },
                                      on: {
                                        "&click": function ($event) {
                                          return _vm.incrementCartItem(item)
                                        },
                                      },
                                    })
                                  : _vm._e(),
                              ]
                            ),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
        ])
      }),
      _vm.cartItems.length > 0
        ? _c(
            "div",
            {
              staticClass: "indented text-right mt-5",
              staticStyle: { "padding-right": "16px" },
            },
            [
              _c("div", { staticClass: "d-inline-block" }, [
                _c("table", { staticClass: "mySumTable" }, [
                  _vm.$store.state.rabattSum > 0 &&
                  !_vm.$store.getters.hidePrices
                    ? _c("tr", [
                        _c("td", [_vm._v("Rabatt")]),
                        _c("td", [
                          _vm._v(
                            "-" +
                              _vm._s(
                                _vm._f("price")(_vm.$store.state.rabattSum)
                              )
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _c("tr", [
                    _c(
                      "td",
                      {
                        staticClass: "pointer",
                        on: {
                          "&click": function ($event) {
                            return _vm.gotoCart.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm.totalSavedByDiscounts > 0
                          ? _c("div", { staticClass: "rabattColor" }, [
                              _vm._v("Rabatt:"),
                            ])
                          : _vm._e(),
                        _vm._m(1),
                      ]
                    ),
                    _c(
                      "td",
                      {
                        staticClass: "pointer",
                        on: {
                          "&click": function ($event) {
                            return _vm.gotoCart.apply(null, arguments)
                          },
                        },
                      },
                      [
                        _vm.totalSavedByDiscounts > 0
                          ? _c("div", { staticClass: "rabattColor" }, [
                              _vm._v(
                                "- " +
                                  _vm._s(
                                    _vm._f("price")(_vm.totalSavedByDiscounts)
                                  )
                              ),
                            ])
                          : _vm._e(),
                        _c("div", [
                          _c(
                            "h3",
                            {
                              class: {
                                rabattColor: _vm.totalSavedByDiscounts > 0,
                              },
                            },
                            [_vm._v(_vm._s(_vm._f("priceTotal")(_vm.total)))]
                          ),
                        ]),
                      ]
                    ),
                  ]),
                ]),
              ]),
              _c("div", [_vm._v("Alle Preisangaben inkl. MwSt.")]),
            ]
          )
        : _vm._e(),
      _vm.showMinHint && _vm.$store.getters.cartSum < _vm.minOrderAmount
        ? _c("div", { staticClass: "indented myWarning" }, [
            _c("div", [
              _vm._v("Es fehlen noch "),
              _c("strong", [
                _vm._v(
                  _vm._s(
                    _vm._f("price")(
                      _vm.minOrderAmount - _vm.$store.getters.cartSum
                    )
                  )
                ),
              ]),
              _vm._v(" für den"),
              _c("br"),
              _c("strong", [
                _vm._v(
                  "Mindestbestellwert von " +
                    _vm._s(_vm._f("price")(_vm.minOrderAmount))
                ),
              ]),
              _vm._v(" für " + _vm._s(_vm.describeUsecase) + " "),
            ]),
            _c("div"),
          ])
        : _vm._e(),
      _vm.$store.getters.orderingEnabled === false
        ? _c("div", { staticClass: "indented myWarning" }, [
            _c("h3", { staticClass: "text-center" }, [
              _vm._v("Aktuell sind keine Online Bestellungen möglich!"),
            ]),
            _vm._v(" Versuche es in ein paar Minuten erneut. "),
          ])
        : _vm._e(),
      _c("notes-dialog", {
        attrs: { dialog: _vm.notesDialog, item: _vm.selectedItem },
        on: {
          close: function ($event) {
            _vm.notesDialog = false
          },
        },
      }),
      _c("tischnummer-dialog", {
        attrs: { dialog: _vm.showTischnummer },
        on: {
          tnumberselected: _vm.tnumberselected,
          close: function ($event) {
            _vm.showTischnummer = false
          },
        },
      }),
    ],
    2
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("table", { staticClass: "theader maxw" }, [
      _c("tr", [
        _c("td", { staticClass: "text-left", staticStyle: { width: "auto" } }, [
          _vm._v(" Artikel "),
        ]),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", [_c("h3", [_vm._v("Gesamt:")])])
  },
]
render._withStripped = true

export { render, staticRenderFns }